// SVG icons (Lucide-style) for each step type
const ICONS = {
  logo: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 512 512" fill="none"><circle cx="256" cy="256" r="256" fill="#47A7F6"/><path d="M362.808 368.808H244.123C178.699 368.808 125.457 315.562 125.457 250.122C125.457 184.703 178.699 131.457 244.124 131.457C309.565 131.457 362.808 184.703 362.808 250.122V368.808Z" stroke="white" stroke-width="12" fill="white"/></svg>',
  settings:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.09a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>',
  inbox:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>',
  users:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  message:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
  contact:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
  check:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
  edit: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>',
  assign:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="m16 11 5-5"/><path d="m21 11-5-5"/></svg>',
  chart:
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>',
  book: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
};

// System images (public paths)
const IMAGES = {
  logo: '/brand-assets/logo.svg',
  bot: '/assets/images/chatwoot_bot.png',
  assistant: '/assets/images/dashboard/captain/assistant-light.svg',
  document: '/assets/images/dashboard/captain/document-light.svg',
  faqs: '/assets/images/dashboard/captain/faqs-light.svg',
};

function buildStepHtml({ icon, image, text }) {
  const iconHtml = icon
    ? `<div class="onboarding-step-icon">${icon}</div>`
    : '';
  const imageHtml = image
    ? `<div class="onboarding-step-image"><img src="${image}" alt="" style="width:64px;height:64px;object-fit:contain;"/></div>`
    : '';
  return `<div class="onboarding-step-content">${imageHtml}${iconHtml}<div class="onboarding-step-text">${text}</div></div>`;
}

// Sidebar selectors for tour steps
const SIDEBAR_SELECTORS = {
  INBOX: '[data-test-name="Inbox"]',
  CONTACTS: '[data-test-name="Contacts"]',
  SETTINGS: '[data-test-name="Settings"]',
};

const CONVERSATION_LIST_SELECTOR = '[data-test-name="ConversationList"]';

const makeStep = ({ popover, htmlContent, element, side }) => {
  const step = {};
  if (element) {
    step.element = element;
  }
  step.popover = {
    ...popover,
    ...(side ? { side } : {}),
    ...(htmlContent ? { description: htmlContent } : {}),
  };
  return step;
};

// Admin tour steps (4 steps with visual highlights)
export function buildAdminSteps(t) {
  return [
    makeStep({
      popover: { title: t('ONBOARDING_TOUR.STEPS.ADMIN.WELCOME') },
      htmlContent: buildStepHtml({
        image: IMAGES.logo,
        text: `<strong>${t('ONBOARDING_TOUR.DESCRIPTION')}</strong>`,
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.INBOX,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.ADMIN.CONVERSATIONS') },
      htmlContent: buildStepHtml({
        icon: ICONS.message,
        text: t('ONBOARDING_TOUR.STEPS.ADMIN.CONVERSATIONS'),
      }),
    }),
    makeStep({
      element: CONVERSATION_LIST_SELECTOR,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.ADMIN.CONVERSATION_LIST') },
      htmlContent: buildStepHtml({
        icon: ICONS.inbox,
        text: t('ONBOARDING_TOUR.STEPS.ADMIN.CONVERSATION_LIST'),
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.CONTACTS,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.ADMIN.CONTACTS') },
      htmlContent: buildStepHtml({
        icon: ICONS.contact,
        text: t('ONBOARDING_TOUR.STEPS.ADMIN.CONTACTS'),
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.SETTINGS,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.ADMIN.FINISH') },
      htmlContent: buildStepHtml({
        icon: ICONS.check,
        text: t('ONBOARDING_TOUR.MODAL.FINAL_MESSAGE'),
      }),
    }),
  ];
}

// Agent tour steps (4 steps with visual highlights)
export function buildAgentSteps(t) {
  return [
    makeStep({
      popover: { title: t('ONBOARDING_TOUR.STEPS.AGENT.WELCOME') },
      htmlContent: buildStepHtml({
        image: IMAGES.logo,
        text: `<strong>${t('ONBOARDING_TOUR.DESCRIPTION')}</strong>`,
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.INBOX,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.AGENT.INBOX') },
      htmlContent: buildStepHtml({
        icon: ICONS.inbox,
        text: t('ONBOARDING_TOUR.STEPS.AGENT.INBOX'),
      }),
    }),
    makeStep({
      element: CONVERSATION_LIST_SELECTOR,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.AGENT.CONVERSATION_LIST') },
      htmlContent: buildStepHtml({
        icon: ICONS.message,
        text: t('ONBOARDING_TOUR.STEPS.AGENT.CONVERSATION_LIST'),
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.CONTACTS,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.AGENT.CONTACT_INFO') },
      htmlContent: buildStepHtml({
        icon: ICONS.contact,
        text: t('ONBOARDING_TOUR.STEPS.AGENT.CONTACT_INFO'),
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.SETTINGS,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.AGENT.FINISH') },
      htmlContent: buildStepHtml({
        icon: ICONS.check,
        text: t('ONBOARDING_TOUR.MODAL.FINAL_MESSAGE'),
      }),
    }),
  ];
}

// Custom role tour steps (4 steps with visual highlights)
export function buildCustomRoleSteps(t) {
  const steps = [
    makeStep({
      popover: { title: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.WELCOME') },
      htmlContent: buildStepHtml({
        image: IMAGES.logo,
        text: `<strong>${t('ONBOARDING_TOUR.DESCRIPTION')}</strong>`,
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.INBOX,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.INBOX') },
      htmlContent: buildStepHtml({
        icon: ICONS.inbox,
        text: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.INBOX'),
      }),
    }),
    makeStep({
      element: CONVERSATION_LIST_SELECTOR,
      side: 'right',
      popover: {
        title: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.CONVERSATION_LIST'),
      },
      htmlContent: buildStepHtml({
        icon: ICONS.message,
        text: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.CONVERSATION_LIST'),
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.CONTACTS,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.CONTACTS') },
      htmlContent: buildStepHtml({
        icon: ICONS.contact,
        text: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.CONTACTS'),
      }),
    }),
    makeStep({
      element: SIDEBAR_SELECTORS.SETTINGS,
      side: 'right',
      popover: { title: t('ONBOARDING_TOUR.STEPS.CUSTOM_ROLE.FINISH') },
      htmlContent: buildStepHtml({
        icon: ICONS.check,
        text: t('ONBOARDING_TOUR.MODAL.FINAL_MESSAGE'),
      }),
    }),
  ];

  return steps;
}

// Checklist items for each role type
export const CHECKLIST_ITEMS = {
  admin: [
    'account_created',
    'company_configured',
    'channel_connected',
    'agent_invited',
    'first_conversation',
    'first_reply',
  ],
  agent: ['account_created', 'view_conversation', 'send_reply', 'use_canned'],
  custom_role_base: ['account_created', 'view_conversation', 'send_reply'],
};

// Optional checklist items for custom role permissions
export const CUSTOM_ROLE_CHECKLIST_MAP = {
  contact_manage: 'view_contact',
  report_manage: 'view_reports',
  knowledge_base_manage: 'manage_knowledge_base',
};

export function buildCustomRoleChecklist(permissions = []) {
  const base = [...CHECKLIST_ITEMS.custom_role_base];
  const uniquePermissions = [...new Set(permissions)];
  uniquePermissions.forEach(perm => {
    const item = CUSTOM_ROLE_CHECKLIST_MAP[perm];
    if (item && !base.includes(item)) {
      base.push(item);
    }
  });
  return base;
}
